import { render, staticRenderFns } from "./PassportSkeleton.vue?vue&type=template&id=530b83fa&"
import script from "./PassportSkeleton.vue?vue&type=script&lang=js&"
export * from "./PassportSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports